import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
// import TagForm from "../components/TagForm"; // Assume you have a form for editing/creating tags

const TagDetailView = () => {
  const userData = useSelector((state) => state?.user);
  const [isEditing, setIsEditing] = useState(false);
  const location = useLocation();
  const { tag } = location.state || {};
  const [updatedTag, setUpdatedTag] = useState(tag);
  const { id } = useParams();
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  if (!tag) {
    return <div>No Tag data available</div>;
  }

  const handleEditToggle = () => {
    setIsEditing(true);
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/tags/delete-tag/${id}`
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/tags");
        }, 2000);
      } else {
        toast.error("Failed to delete tag.");
      }
    } catch (error) {
      console.log("🚀 ~ handleConfirmDelete ~ error:", error);
      toast.error(error?.response?.data?.message || "Network error. Please try again.");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  return (
    <>
      {!isEditing ? (
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={styles.container}>
          <div style={styles.header}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                onClick={() => navigate(-1)}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.3333 15.9998C29.3333 8.64784 23.3519 2.6665 15.9999 2.6665C8.64792 2.6665 2.66659 8.64784 2.66659 15.9998C2.66659 23.3518 8.64792 29.3332 15.9999 29.3332C23.3519 29.3332 29.3333 23.3518 29.3333 15.9998ZM10.1146 15.9998L17.7239 8.3905L19.6093 10.2758L13.8853 15.9998L19.6093 21.7238L17.7239 23.6092L10.1146 15.9998Z"
                    fill="#27B99A"
                  />
                </svg>
              </button>
              <h2 style={styles.title}>Tag Profile</h2>
            </div>

            {/* <div style={styles.buttonContainer}>
              <button onClick={handleDelete} style={styles.deleteButton}>
                Delete
              </button>
              <button onClick={handleEditToggle} style={styles.editButton}>
                Edit
              </button>
            </div> */}
          </div>
            <div style={styles.infoContainer}>
              <div style={styles.infoRow}>
                <span style={styles.span}>Name</span>
                <span style={styles.span}>{tag.name}</span>
              </div>
              <div style={styles.infoRow}>
                <span style={styles.span}>Status</span>
                <span style={styles.span}>{tag.status}</span>
              </div>
            </div>
            {showDeleteModal && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContainer}>
                  <p style={styles.modalText}>
                    Are you sure you want to delete this tag?
                  </p>
                  <button
                    style={styles.confirmButton}
                    onClick={handleConfirmDelete}
                    disabled={isDeleting}
                  >
                    {isDeleting ? "Deleting..." : "Yes, delete"}
                  </button>
                  <button
                    style={styles.cancelButton}
                    onClick={handleCloseDeleteModal}
                    disabled={isDeleting}
                  >
                    No, keep it
                  </button>
                </div>
              </div>
            )}
            <ToastContainer />
          </div>
        </div>
      ) : (
        <></>
        // <TagForm tag={updatedTag} />
      )}
    </>
  );
};

const styles = {
  container: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "Poppins",
    overflow: "hidden",
    width: "600px",
  },
  header: {
    alignItems: "center",
    backgroundColor: "#064260",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 35px",
  },
  title: {
    fontSize: "21px",
    fontWeight: 600,
    margin: 0,
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
  },
  editButton: {
    backgroundColor: "#27B99A",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  deleteButton: {
    backgroundColor: "#ED3A3A",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  infoContainer: {
    padding: "0",
  },
  infoRow: {
    borderBottom: "1px solid #eee",
    display: "flex",
    fontSize: "1em",
    justifyContent: "space-between",
    padding: "20px 35px",
  },
  span: {
    fontSize: "17px",
    fontWeight: 600,
  },
  modalOverlay: {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
  },
  modalContainer: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "396px",
    padding: "35px 46px 55px 46px",
    textAlign: "center",
  },
  modalText: {
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "1.5",
  },
  confirmButton: {
    border: "none",
    color: "#064260",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  },
  cancelButton: {
    border: "none",
    color: "#064260",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  },
};

export default TagDetailView;
